module.exports = __webpack_public_path__ + "img/roleplay.712026d3.png";